module.exports = __webpack_public_path__ + "fonts/quicksand-v20-latin-500.79eb4bee.eot";